module.exports = __webpack_public_path__ + "static/media/html.a7931782.svg";